import React from "react";
import { Form, Input } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useBanks, useOptionsBanks } from "hook/finance/withdraw/useWithdraw";
//
//component
import DialogBanks from "../dialog_banks";
//redux
//selector
//actions
//utils
//hook
//str
const WithdrawBankName = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const code = Form?.useWatch("code", form) || null;
  const { handleOpen } = useBanks();
  const { banks } = useOptionsBanks();

  const value =
    banks?.find((item) => item?.code === code)?.name || "Chọn Ngân Hàng";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <span>Chọn Ngân Hàng</span>
      <Input
        onClick={() => handleOpen(form)}
        variant="filled"
        style={{ minHeight: 40 }}
        readOnly
        inputMode="none"
        value={value}
        placeholder="Ngân hàng nhận tiền"
        suffix={<DownOutlined style={{ color: "#aeaeae" }} />}
      />
      <Form.Item name="code" hidden />
      <Form.Item name="openBank" initialValue={false} hidden />
      <DialogBanks />
    </div>
  );
};
export default WithdrawBankName;
